import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import walletB from "../assets/img/cards/MONEDERO_B.svg";
import TableWallet from '../components/TableWallet';
import WalletMobile from '../components/WalletMobile';
import WalletCard from '../components/WalletCard';
import { useStores } from "../hooks/useStores";

const Wallet = observer(() => {
  const { t } = useTranslation();
  const { myTimStore } = useStores();
  const { getWalletOperations, capping, walletOperations, headersWalletOpertations, card } = myTimStore;
  
  const totalItems = parseInt(headersWalletOpertations.totalresults, 10);

  return (
    <>
      {walletOperations && walletOperations.length > 0 ? (
        <div data-testid="data">
          <div className="page-title-mobile">
            {t("carnet").replace("/", " ")}
            <img src={walletB} alt="img" />
          </div>
          <WalletCard movements={walletOperations} carnet={card} capping={capping} />
          <div>
            <TableWallet movements={walletOperations} totalItems={totalItems} getMoreData={getWalletOperations} />
            <WalletMobile movements={walletOperations} totalItems={totalItems} getMoreData={getWalletOperations} />
          </div>
        </div>
      ) : (
        <div data-testid="no-data" className="no-items">
          {t("no_items")}
        </div>
      )}
    </>
  );
});

export default Wallet;
